import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiSearch, FiUser, FiShoppingBag, FiMenu, FiX } from 'react-icons/fi';
import { useCart } from '../../contexts/CartContext';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const { cart } = useCart();
  const cartCount = cart.itemCount || 0;

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery)}`);
      setIsSearchOpen(false);
      setSearchQuery('');
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <button 
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Menu"
        >
          {isMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        <Link to="/" className="logo">
          BASICK
        </Link>

        <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
          <Link to="/products?category=t-shirts" onClick={() => setIsMenuOpen(false)}>T-Shirts</Link>
          <Link to="/coming-soon?category=collections" onClick={() => setIsMenuOpen(false)}>Collections</Link>
          <Link to="/lookbook" onClick={() => setIsMenuOpen(false)}>Lookbook</Link>
          <Link to="/about" onClick={() => setIsMenuOpen(false)}>About</Link>
        </nav>

        <div className="header-actions">
          <button 
            className="search-toggle"
            onClick={() => setIsSearchOpen(!isSearchOpen)}
            aria-label="Search"
          >
            <FiSearch size={20} />
          </button>
          <Link to="/account" className="account-link" aria-label="Account">
            <FiUser size={20} />
          </Link>
          <Link to="/cart" className="cart-link" aria-label="Cart">
            <FiShoppingBag size={20} />
            {cartCount > 0 && (
              <span className="cart-count">{cartCount}</span>
            )}
          </Link>
        </div>
      </div>

      {isSearchOpen && (
        <div className="search-bar">
          <form onSubmit={handleSearch} className="search-form">
            <input
              type="text"
              placeholder="Search products, brands, collections..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
              autoFocus
            />
            <button type="submit" className="search-submit">
              <FiSearch size={20} />
            </button>
            <button 
              type="button" 
              className="search-close"
              onClick={() => setIsSearchOpen(false)}
              aria-label="Close search"
            >
              <FiX size={20} />
            </button>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header;